import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import da from './i18n/locales/da'
import en from './i18n/locales/en'
import fi from './i18n/locales/fi'
import no from './i18n/locales/no'
import sv from './i18n/locales/sv'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv },
      en: { translation: en },
      no: { translation: no },
      da: { translation: da },
      fi: { translation: fi },
    },
    fallbackLng: 'sv',
    debug: import.meta.env.DEV,
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  })
